import { render, staticRenderFns } from "./edit-goods-modal.vue?vue&type=template&id=2b85fda1&"
import script from "./edit-goods-modal.vue?vue&type=script&lang=js&"
export * from "./edit-goods-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports